<template>
  <div class="container">
    <div class="nav-tab">
      <div style="display: flex">
        <img src="../../../assets/images/arrow.png" class="ims" alt="" />
        <div>您的当前位置是：首页-更多值班</div>
      </div>
      <div
        class="hover-underline"
        style="display: flex; margin-right: 56px"
        @click="returnshow"
      >
        <div style="display: inline-block">
          <img src="../../../assets/images/return.png" class="imgs" alt="" />
        </div>
        返回
      </div>
    </div>
    <div class="content">
      <div>
        <div>值班时间：{{this.dateArray[0].date}}</div>
        <table border="1" style="border-collapse:collapse;margin: 20px 0;">
          <tr>
            <td rowspan="3">贵池大队</td>
            <td rowspan="3">{{ zhongdui.gcdd }}</td>
            <td>清溪站</td>
            <td>{{ zhongdui.qxz }}</td>
            <td style="width: 220px;">值班电话:0566-3395119</td>
          </tr>
          <tr>
            <td>清风站</td>
            <td>{{ zhongdui.qfz }}</td>
            <td>值班电话:0566-2124114</td>
          </tr>
          <tr>
            <td>园区站</td>
            <td>{{ zhongdui.yqz }}</td>
            <td>值班电话:18956601445</td>
          </tr>
          <tr>
            <td rowspan="2">东至大队</td>
            <td rowspan="2">{{ zhongdui.dzdd }}</td>
            <td>尧渡站</td>
            <td>{{ zhongdui.ydz }}</td>
            <td>值班电话:0556-7015119</td>
          </tr>
          <tr>
            <td>香隅站</td>
            <td>{{ zhongdui.xyz }}</td>
            <td>值班电话:0566-8171119</td>
          </tr>
          <tr>
            <td>青阳大队</td>
            <td>{{ zhongdui.qydd }}</td>
            <td>蓉城站</td>
            <td>{{ zhongdui.rcz }}</td>
            <td>值班电话:0566-5026653</td>
          </tr>
          <tr>
            <td>石台大队</td>
            <td>{{ zhongdui.stdd }}</td>
            <td>仁里站</td>
            <td>{{ zhongdui.rlz }}</td>
            <td>值班电话:0566-6022661</td>
          </tr>
          <tr>
            <td rowspan="2">九华山大队</td>
            <td rowspan="2">{{ zhongdui.jhsdd }}</td>
            <td>九子山站</td>
            <td>{{ zhongdui.jzsz }}</td>
            <td>值班电话:0566-2831319</td>
          </tr>
          <tr>
            <td>柯村站</td>
            <td>{{ zhongdui.kcz }}</td>
            <td>值班电话:0566-3268512</td>
          </tr>
          <tr>
            <td>永明路特勤站</td>
            <td  colspan="3">{{ zhongdui.ymltqz }}</td>
            <td>值班电话:0566-3223119</td>
          </tr>
        </table>
      </div>
    </div>  
  </div>
</template>

<script>
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

import { listzhongdui } from "../../../api/index";
export default {
  components: {
    ElImageViewer,
  },
  data() {
    return {
      isShowPics: false,
      dateArray: [],
      zhongdui:{},
    };
  },
  mounted() {
    this.generateWeekDates();
  },
  methods: {
    returnshow() {
      this.$emit("setCilck");
    },
    getList(){
      const days = this.dateArray[0].dateparmers
      listzhongdui({ dutyTime: days, pageNum: 1, pageSize: 7 }).then((res) => {
        this.zhongdui = res.data.data.list[0];
        console.log(this.zhongdui, "zhongdui");
      });
    },
    // 生成从今天起的一周日期并计算周几
    generateWeekDates() {
      let today = new Date(); // 获取当前日期
      let weekDates = []; // 用于存储日期和星期几信息

      // 中文星期数组
      const chineseWeekdays = [
        "星期天",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];

      // 循环7天并计算每一天
      for (let i = 0; i < 7; i++) {
        let currentDate = new Date(today); // 复制当前日期
        currentDate.setDate(today.getDate() + i); // 设置日期为今天起的第 i 天

        // 格式化日期为 YYYY-MM-DD 格式
        let dateString = `${currentDate.getFullYear()}年${(
          currentDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}月${currentDate
          .getDate()
          .toString()
          .padStart(2, "0")}日`;
        let dateparmers = `${currentDate.getFullYear()}-${(
          currentDate.getMonth() + 1
        )
          .toString()
          .padStart(2, "0")}-${currentDate
          .getDate()
          .toString()
          .padStart(2, "0")}`;

        // 获取星期几的中文表示
        let weekday = chineseWeekdays[currentDate.getDay()];

        // 将日期和星期几存入数组
        weekDates.push({
          date: dateString,
          weekday: weekday,
          dateparmers: dateparmers,
        });
      }

      // 将结果存储在组件的 data 中
      this.dateArray = weekDates;
      this.getList();
      console.log(this.dateArray, "this.dateArray");
    },
  },
};
</script>

<style scoped lang="scss">
#map {
  width: 100%;
  height: 398px;
}
.dolongw {
  width: 100%;
  padding: 40px;
  .dolong {
    display: flex;
    justify-content: space-between;
    width: calc(100% - 80px);
    height: 40px;
    line-height: 35px;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #f5f5f5;
    padding-left: 20px;
    .dowl {
      width: 34px;
      .ims {
        width: 12px;
        height: 14px;
        vertical-align: middle;
      }
    }
    .file {
      display: flex;
      .image {
        display: inline-block;
        height: 40px;
        .ims {
          width: 12px;
          height: 14px;
          vertical-align: middle;
        }
      }
      .title {
        margin-left: 8px;
        font-size: 14px;
        color: #999999;
      }
    }
  }
}
.container {
  width: 100%;
  background: #f0f5ff;
}

.nav-tab {
  width: 1120px;
  height: 48px;
  background: #f5f5f5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  .ims {
    width: 23px;
    height: 20px;
    margin-left: 40px;
  }
  .imgs {
    width: 16px;
    margin: 0;
    height: 14px;
    vertical-align: middle;
    margin-right: 8px;
  }
  div {
    font-size: 16px;
    color: #2b56ac;
    margin-left: 16px;
  }
}
.hover-underline {
  cursor: pointer; /* 鼠标悬停时显示手形光标 */
}

.hover-underline:hover {
  text-decoration: underline; /* 悬停时添加下划线 */
}

.content {
  width: 1120px;
  margin: 0 auto;
  margin-top: 40px;
    display: flex;
    justify-content: center;
  
  .title {
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
    margin-bottom: 16px;
  }

  .line {
    width: 1040px;
    height: 2px;
    margin: 0 auto;
    margin-bottom: 16px;
    background: #2e5bb6;
  }

  .info {
    text-align: center;
  }

  .browse {
    width: 1040px;
    height: 16px;
    margin: 0 auto;
    font-size: 14px;
    color: #333333;
    position: relative;

    .count {
      position: absolute;
      right: 0;
    }
  }

  .img-box {
    width: 510px;
    height: 340px;
    margin: 0 auto;
    margin-bottom: 20px;
    img {
      width: 510px;
      height: 340px;
    }
  }
  .news-content {
    width: 1040px;
    margin: 0 auto;
    text-indent: 2em;
    ::v-deep img {
      max-width: calc(100% - 80px);
    }
  }
}

.bottom-info {
  width: 1120px;
  height: 100px;
  background: #0e67ab;
  color: #fff;
  font-size: 14px;
  margin: 0 auto;
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-box div {
    margin: 6px 0;
    text-align: center;
  }
}
.red {
  text-align: center;
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 16px;
  color: #e71111;
}
td {
  width: 160px;
  height: 40px;
  text-align: center;
  font-size: 14px;
}

</style>
